import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchSafeDto } from '../../types/safes.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useUpdate = () => {
  const { mutate: update, isPending } = useAppMutation([QueryKey.PATCH_SAFE], {
    mutationFn: ({
      companyId,
      data,
      safeId,
    }: {
      companyId: string;
      data: PatchSafeDto;
      safeId: string;
    }) =>
      ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'safes', safeId] },
        { body: data },
      ),
  });
  return { update, isPending };
};
